import { IInjectable } from '@uirouter/angularjs';
import { ApiService } from '../services/api/types';

export function PrinterDataResolver(): IInjectable {
  return [
    'ApiService',
    function (ApiService: ApiService) {
      return ApiService.tickets.printers.list();
    },
  ];
}
